import React, { Component } from "react";
import { connect } from "react-redux";
import {bindActionCreators} from"redux";
import { WithStyles, Typography, Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import PerfectScrollbar from "react-perfect-scrollbar";
import { ContentOwnersStyle } from "../styles/ContentOwnersStyle";

import ContentOwnersTable from "./ContentOwnersTable";
import { ContentSubType } from "../../test-template/types/ContentSubTypeBody";
import { testTemplateService } from "../../test-template/services/testTemplateService";
import MyPATCalendar from "../../common/MyPATCalendar";
import TestOwnersTable from "./TestOwnersTable";
import { Author, ContentRequest, Question, Roles } from "../types/ContentRequest";
import _ from "lodash";
import { RequestContentType } from "../types/ContentRequestCreate";
import clsx from "classnames";
import { getAuthUserClientId, hasTestOwnerStartedWork, hasWorkStartedForASubject } from "../helpers/createContentRequest";
import {setUserByRole} from "../actions/contentRequestActions";
import { Subject } from "../../course/modals/CourseBasicInfo";
import MyPATBaseSection from "../../common/MyPATBaseSection";
import CustomInfoIcon from "../../common/CustomInfoIcon";
//@ts-ignore
interface SelectContentOwnersProps
  extends WithStyles<typeof ContentOwnersStyle> {
  classes: any;
  contentsubType: ContentSubType[];
  subjects: any[];
  selectedSubjects: string[];
  transferToParent: (requestData: ContentRequest) => void;
  requestData: ContentRequest;
  requestContentType: RequestContentType;
  setUserByRole:Function;
  userByRole:any,
  toShowTestOwners?: boolean;
  handleRelevantOwnerOnly?: boolean;
}

interface SelectContentOwnersState {
  isOpenSelectContentOwnersDialog: boolean;
  questionSubTypes: ContentSubType[];
}

class SelectContentOwners extends Component<
  SelectContentOwnersProps,
  SelectContentOwnersState
> {
  authUserClientId: string;
  constructor(props: SelectContentOwnersProps) {
    super(props);
    this.state = {
      isOpenSelectContentOwnersDialog: false,
      questionSubTypes: [],
    };
    this.handleTestOwnerTable = this.handleTestOwnerTable.bind(this);
    this.setUserRoleMapping=this.setUserRoleMapping.bind(this);
    this.authUserClientId = getAuthUserClientId();
  }
 
  componentDidMount() {
    this.fetchQuestionSubTypes();
    this.setUserRoleMapping();
  }
  componentDidUpdate(prevProps:SelectContentOwnersProps){
    if(prevProps.selectedSubjects!==this.props.selectedSubjects){
      this.setUserRoleMapping();
    }
  }
  addAuthorsInUserRoleMap=(authors:Author[],newUserByRole:any)=>{
    authors.forEach((author)=>{
      if(newUserByRole.hasOwnProperty(author.id)){
        newUserByRole[author.id]={type:author.type,count:newUserByRole[author.id].count+1};
      }else{
        newUserByRole[author.id]={type:author.type,count:1};
      }
    })
  }
  setUserRoleMapping=()=>{
    const {requestData,userByRole}=this.props;
    const newUserByRole={...userByRole};
    console.log({requestData,userByRole});
    const subjects=_.get(requestData,"requestInfo.details.subjects",[]);
    const testDetails=_.get(requestData,"requestInfo.details.testDetails",{});
    subjects.forEach((subject:Subject)=>{
      const questions=_.get(subject,"questions",[]);
      questions.forEach((question:Question)=>{
        const authors=_.get(question,"authors",[]);
        this.addAuthorsInUserRoleMap(authors,newUserByRole);
      })
    });
   if(!_.isEmpty(testDetails)){
    const testAuthor=_.get(testDetails,"authors",[]);
    this.addAuthorsInUserRoleMap(testAuthor,newUserByRole)
   } 
    this.props.setUserByRole(newUserByRole);
  }
  fetchQuestionSubTypes = async () => {
    try {
      const data = await testTemplateService.getContentSubType("question");
      this.setState({
        questionSubTypes: data,
      });
    } catch (error) {
      console.log(error);
    }
  };

  handleContentOwnersTableChange = ({
    subjectId,
    questions,
  }: {
    questions: Question[];
    subjectId: string;
  }) => {
    const { transferToParent, requestData } = this.props;
    const newRequestData = { ...requestData };
    const subject = newRequestData.requestInfo.details.subjects.find(
      ({ id }) => id === subjectId
    );
    if (subject) {
      subject.questions = questions;
    }
    transferToParent(newRequestData);
  };

  isContentOwnerSectionDisabled = (questions: Question[]) => {
    return hasWorkStartedForASubject(questions);
  };

  renderContentOwnersTableBySubjects = (selectedSubjectsData: any[]) => {
    const { classes, requestData } = this.props;
    const { questionSubTypes } = this.state;
    
    return selectedSubjectsData.map(({ _id, name }) => {
      const subject = requestData.requestInfo.details.subjects.find(
        ({ id }) => id === _id
      );
      const questions = _.get(subject, "questions", []);
      const isSectionDisabled = this.isContentOwnerSectionDisabled(questions);
      return (
        <Grid
          className={clsx(
            classes.mainContainer,
            isSectionDisabled && classes.disabledSection
          )}
          key={_id}
        >
          <span className={classes.containerHeading}>{name}</span>
          <Grid className={classes.mt20}>
            <ContentOwnersTable
              transferToParent={this.handleContentOwnersTableChange}
              questionSubTypes={questionSubTypes}
              questions={questions}
              subjectId={_id}
              isSectionDisabled={isSectionDisabled}
            />
          </Grid>
        </Grid>
      );
    });
  };
  handleTestOwnerTable(newRequestData: ContentRequest) {
    const { requestData, transferToParent } = this.props;
    transferToParent(newRequestData);
  }
  handleDeadlineChange = (fieldName: string, value: any) => {
    const { requestData, transferToParent, handleRelevantOwnerOnly } = this.props;
    const newRequestData = { ...requestData };
    
    const newOwners = newRequestData.requestInfo.owners.map((owner) => {
      if (owner.type === "test-compiler" || (handleRelevantOwnerOnly && this.authUserClientId !== owner.client.id)) {
        return owner;
      }
      const newRoles = { ...owner.roles };

      // @ts-ignore
      newRoles[fieldName] = { endDate: new Date(value) };

      return {
        ...owner,
        roles: newRoles,
      };
    });
    newRequestData.requestInfo.owners = newOwners;
    transferToParent(newRequestData);
  };

  isTestOwnerSectionDisabled = () => {
    const { requestData } = this.props;
    return hasTestOwnerStartedWork(requestData);
  };

  render() {
    const {
      classes,
      contentsubType,
      requestContentType,
      requestData,
      toShowTestOwners = true,
      subjects,
      selectedSubjects
    } = this.props;

    const selectedSubjectsData = subjects.filter(({ _id }) =>
      selectedSubjects.includes(_id)
    );
    
    const questionOwner = requestData.requestInfo.owners.find((owner) => {
      const type = _.get(owner, 'type', '');
      const clientId = _.get(owner, 'client.id', '');
      return type === "subject" && clientId === this.authUserClientId
    });
    let authorDeadlinesByRoles: Roles = defaultEndDates;
    if (questionOwner) {
      const roles = _.get(questionOwner, "roles");
      if (roles) {
        authorDeadlinesByRoles = roles;
      }
    }

    const { requestInfo } = requestData;

    const requestEndDate = requestInfo.endDate
      ? new Date(requestInfo.endDate)
      : requestInfo.endDate;

    const requestStartDate = requestInfo.startDate
      ? new Date(requestInfo.startDate)
      : requestInfo.startDate;

    const creatorEndDate = _.get(authorDeadlinesByRoles, "creator.endDate", "");

    const evaluatorEndDate = _.get(
      authorDeadlinesByRoles,
      "evaluator.endDate",
      ""
    );

    const langEvaluatorEndDate = _.get(
      authorDeadlinesByRoles,
      "languageEvaluator.endDate",
      ""
    );
    const moderatorEndDate = _.get(
      authorDeadlinesByRoles,
      "moderator.endDate",
      ""
    );
    const publisherEndDate = _.get(
      authorDeadlinesByRoles,
      "publisher.endDate",
      ""
    );

    const isTestOwnerDisabled = this.isTestOwnerSectionDisabled();

    return (
      <MyPATBaseSection sectionId="selectContentOwners">
        <Grid className={classes.whiteCard}>
          <Typography
            className={[classes.mainHeading, classes.paddingB15].join(" ")}
          >
            Select Content Owners
            
          </Typography>
          <Grid container justify="flex-start">
            {this.renderContentOwnersTableBySubjects(selectedSubjectsData)}
            {selectedSubjectsData.length > 0 && (
              <Grid className={[classes.mainContainer, classes.plr27].join(" ")}>
                <span className={classes.containerHeading}>
                  Specify Deadlines for your Content&nbsp;
                  <CustomInfoIcon
                    infoDialogContentType="Specify Deadlines for your Content"
                    isInfoIcon={true}
                    isRightArrow={false}
                    isCenterArrow={true}
                    knowMoreAbout={false}
                    dialogTitle="Specify Deadlines for your Content"
                    imageURL="/assets/svg/contentRequest/Deadlines.svg"
                    dialogPara=""
                    details="Click to know more"
                    toolTipDirection="top"
                    htmlElement={
                      <>
                        <Grid container justify="center" className={classes.mtb30}>
                          <Typography className={classes.font16}>In this section you can define the deadlines for the above content owners which will be common for each role category i.e for all the creators, there will be one deadline which can be defined under content creation category. 
                          </Typography>
                        <Typography className={classes.font16}>Similarly each deadline field is dedicated to respective role category</Typography>
                        </Grid>
                      </>
                    }
                  />
                </span>
                <Grid className={classes.mt20}>
                  <Grid container spacing={24}>
                    <Grid item xs={6} className={classes.customCalendar}>
                      <MyPATCalendar
                        fullWidthControl
                        onChange={(date: any) =>
                          this.handleDeadlineChange("creator", date)
                        }
                        date={creatorEndDate}
                        disabled={!requestEndDate || !requestStartDate}
                        minDate={requestStartDate}
                        maxDate={requestEndDate}
                        errorText="Creation date cannot be less than request start date or more that request end date"
                        label="Content Creation"
                      />
                    </Grid>
                    <Grid item xs={6} className={classes.customCalendar}>
                      <MyPATCalendar
                        fullWidthControl
                        onChange={(date: any) =>
                          this.handleDeadlineChange("evaluator", date)
                        }
                        date={evaluatorEndDate}
                        minDate={creatorEndDate}
                        maxDate={requestEndDate}
                        disabled={!requestEndDate || !creatorEndDate}
                        errorText="Evaluation date cannot be less than creator's end date or more that request end date"
                        label="Content Evaluation"
                      />
                    </Grid>

                    <Grid item xs={6} className={classes.customCalendar}>
                      <MyPATCalendar
                        fullWidthControl
                        onChange={(date: any) =>
                          this.handleDeadlineChange("languageEvaluator", date)
                        }
                        date={langEvaluatorEndDate}
                        disabled={!requestEndDate || !evaluatorEndDate}
                        minDate={evaluatorEndDate}
                        maxDate={requestEndDate}
                        errorText="Language Evaluation date cannot be less than evaluator's end date or more that request end date"
                        label="Content Lang. Evaluation"
                      />
                    </Grid>
                    <Grid item xs={6} className={classes.customCalendar}>
                      <MyPATCalendar
                        fullWidthControl
                        onChange={(date: any) =>
                          this.handleDeadlineChange("moderator", date)
                        }
                        date={moderatorEndDate}
                        disabled={!requestEndDate || !langEvaluatorEndDate}
                        minDate={langEvaluatorEndDate}
                        maxDate={requestEndDate}
                        errorText="Moderation date cannot be less than lang. evaluator's end date or more that request end date"
                        label="Content Moderation"
                      />
                    </Grid>
                    <Grid item xs={6} className={classes.customCalendar}>
                      <MyPATCalendar
                        fullWidthControl
                        onChange={(date: any) =>
                          this.handleDeadlineChange("publisher", date)
                        }
                        date={publisherEndDate}
                        disabled={!requestEndDate || !moderatorEndDate}
                        minDate={moderatorEndDate}
                        maxDate={requestEndDate}
                        errorText="Publishing date cannot be less than moderator's end date or more that request end date"
                        label="Content Publisher"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )}
            
            {requestContentType === RequestContentType.TEST && toShowTestOwners && (
              <Grid
                className={[
                  classes.mainContainer,
                  classes.plr27,
                  isTestOwnerDisabled ? classes.disabledSection : "",
                ].join(" ")}
              >
                <span className={classes.containerHeading}>Test Owner</span>
                <Grid className={classes.mt20}>
                  <TestOwnersTable
                    contentsubType={contentsubType}
                    requestData={requestData}
                    transferToParent={this.handleTestOwnerTable}
                    isSectionDisabled={isTestOwnerDisabled}
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </MyPATBaseSection>
    );
  }
}

const defaultEndDates = {
  creator: { endDate: "" },
  evaluator: { endDate: "" },
  languageEvaluator: { endDate: "" },
  moderator: { endDate: "" },
  publisher: { endDate: "" },
};

const mapStateToProps = (state: any) => {
  return {
    subjects: state.contentRequestReducer.contentRequestCreateReducer.subjects,
    selectedSubjects:
      state.contentRequestReducer.contentRequestCreateReducer.selectedSubjects,
    userRoleMap: state.contentRequestReducer.contentRequestCreateReducer.userRoleMap,

  };
};
const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  setUserByRole
}, dispatch);

export default connect(mapStateToProps,mapDispatchToProps)(
  // @ts-ignore
  withStyles(ContentOwnersStyle)(SelectContentOwners)
);
